import { render } from "./eventLeague.vue?vue&type=template&id=0a9a148e"
import script from "./eventLeague.vue?vue&type=script&lang=js"
export * from "./eventLeague.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__